import type { VoiceCapture } from "./createVoiceCapture";

// A capture holds a MediaStream, so it cannot live in Redux; ChatWindow does not know it exists,
// so it cannot travel as a prop. One module-level slot is what lets RecordPulse and the level
// meter poll getLevel() on their own rAF without either of those.
//
// Exactly one capture may exist at a time. That is enforced rather than assumed: the session
// watcher is takeLatest, so a second recording cancels the first, whose finally closes its
// capture and clears this slot before the new one writes.
let current: undefined | VoiceCapture;

export const setCurrentVoiceCapture = (capture: undefined | VoiceCapture): void => {
  current = capture;
};

export const getCurrentVoiceCapture = (): undefined | VoiceCapture => current;

// An AudioContext must be created and resumed inside the click handler's own call stack —
// Safari honours resume() nowhere else — and it is not serializable, so it cannot ride in an
// action payload. The handler leaves it here and the saga takes it.
let pendingAudioContext: AudioContext | undefined;

export const setPendingAudioContext = (context: AudioContext | undefined): void => {
  pendingAudioContext = context;
};

export const takePendingAudioContext = (): AudioContext | undefined => {
  const context = pendingAudioContext;
  pendingAudioContext = undefined;
  return context;
};
